import React from 'react';

type HTMLTag = keyof JSX.IntrinsicElements;

interface SanitizeProps extends Omit<React.HTMLAttributes<HTMLElement>, 'as'> {
  as?: HTMLTag;
  children: React.ReactNode;
  /** When true: fully hidden in replay. When false/omit: sanitize (mask). Only one attribute is applied. */
  phiHidden?: boolean;
}

export const Sanitize: React.FC<SanitizeProps> = ({
  as: Component = 'span',
  children,
  phiHidden = false,
  className,
  ...rest
}) => {
  return React.createElement(
    Component,
    {
      className,
      ...(phiHidden ? { 'data-openreplay-hidden': true } : { 'data-openreplay-sanitize': true }),
      ...rest,
    },
    children,
  );
};
